/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleFeesDto
 */
export interface SimpleFeesDto {
    /**
     * Unique identifier of the fee
     * @type {string}
     * @memberof SimpleFeesDto
     */
    id: string;
    /**
     * Fee label
     * @type {string}
     * @memberof SimpleFeesDto
     */
    label: string;
    /**
     * Fee amount including taxes
     * @type {number}
     * @memberof SimpleFeesDto
     */
    priceTTC: number;
}

/**
 * Check if a given object implements the SimpleFeesDto interface.
 */
export function instanceOfSimpleFeesDto(value: object): value is SimpleFeesDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('priceTTC' in value) || value['priceTTC'] === undefined) return false;
    return true;
}

export function SimpleFeesDtoFromJSON(json: any): SimpleFeesDto {
    return SimpleFeesDtoFromJSONTyped(json, false);
}

export function SimpleFeesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleFeesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'priceTTC': json['priceTTC'],
    };
}

export function SimpleFeesDtoToJSON(json: any): SimpleFeesDto {
    return SimpleFeesDtoToJSONTyped(json, false);
}

export function SimpleFeesDtoToJSONTyped(value?: SimpleFeesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'priceTTC': value['priceTTC'],
    };
}

